<template>
    <div style="display: flex;" class="mt10 mb10">
        <a class="btn btn_basics btn_fit no-drag"
           :class="tabStatusProps === 'note'? 'blue' : 'gray'"
            @click="$emit('changeTabStatus', 'note')">
            {{ this.$t('RMC.RMC_note')}}
        </a>
        <a class="btn btn_basics btn_fit no-drag"
           :class="tabStatusProps === 'symptom'? 'blue' : 'gray'"
           @click="$emit('changeTabStatus', 'symptom')">
            {{ this.$t('patient_symptoms')}}
        </a>
    </div>
</template>
<script>
    export default {
        props: ['tabStatusProps'],
        methods: {}
    }
</script>